<template>
    <div>
        <div class="img-uploader position-relative">
            <div class="img-container" @click.stop="openFileSelection" :style="getImgContainerStyle()">
                <img :src="getImgSrc()" style="display:block;max-height: 100%; max-width: 100%;margin: 0 auto"
                />
            </div>
            <div class="button-container" :style="getButtonContainerStyle()">
                <div class="d-flex flex-row justify-content-center">
                    <div>
                        <b-button v-show="!isUndefined(url) && url.toString().length>0 && showPreviewButton"
                                  variant="light" size="sm" @click.prevent.stop="previewFile" title="Просмотр"
                                  class="button-icon-only preview-button"
                        >
                            <i class="fa fa-eye"/>
                        </b-button>
                    </div>
                    <div>
                        <b-button v-show="!isUndefined(url) && url.toString().length>0 && showDownloadButton"
                                  variant="light" size="sm" @click.prevent.stop="saveFile" title="Сохранить"
                                  class="button-icon-only save-button"
                        >
                            <i class="fa fa-download"/>
                        </b-button>
                    </div>
                    <div>
                        <b-button v-show="!isUndefined(url) && url.toString().length>0 && !disabled"
                                  variant="light" size="sm" @click.prevent.stop="buttonDeleteFileClicked"
                                  title="Удалить"
                                  class="button-icon-only delete-button"
                        >
                            <i class="fa fa-times"/>
                        </b-button>
                    </div>
                </div>
            </div>

            <div v-show="!isUndefined(url) && url.toString().length===0 && !disabled"
                 :style="getMessageTextStyle()" class="small text-muted" @click="openFileSelection">
                {{labelText}}
            </div>
        </div>

        <p v-show="showTitle" class="text-sm-center mt-2">{{ attachment.Attachment }}</p>
        <div v-show="progressBarActive">
            <progress :value="progressBarPercent" max="100"/>
        </div>
        <input @change="chunkFile" ref="fileInputRef" class="d-none" type="file" :accept="getFileExtensions"/>

        <div v-show="errExist" class="alert alert-danger ms-1 me-1 small">{{ errMsg }}</div>

        <b-modal ref="modal-preview" hide-footer centered size="lg"
                 header-class="custom-modal-header" body-class="custom-modal-body" :title="attachment.Attachment"
        >
            <img v-if="getFileType==='img'" :src="isUndefined(url) ? '' : url" width="100%" height="100%"/>
            <object v-if="getFileType==='pdf'" :data="isUndefined(url) ? '' : url"
                    type="application/pdf" width="100%" height="500"
            />
        </b-modal>

        <b-modal ref="modal-delete-confirmation" hide-footer hide-header centered>
            <p class="text-center">Удалить прикрепленный файл?</p>
            <div class="d-flex flex-row flex-center">
                <b-button variant="primary" @click="buttonDeleteConfirmOkClicked" class="w-80px">ОК</b-button>
                <b-button variant="secondary" @click="buttonDeleteConfirmCancelClicked" class="ml-3 w-80px">Отмена
                </b-button>
            </div>
        </b-modal>

    </div>
</template>

<script>
    import axios from "axios"

    export default {
        name: "image-uploader-component",
        props: {
            attachment: {
                Attachment: String,
                FileKey: String,
                AllowedExtensions: Array,
                FileMaxSize: Number,

                AttachmentURL: String,
                PreviewAttachmentURL: String,
                RVV: String,
                FileExtension: String,
            },

            attachmentFor: String,
            attachmentParams: Object,
            recordUid: String,
            disabled: Boolean,
            width: String,
            height: String,
            showPreviewButton: Boolean,
            showDownloadButton: Boolean,
            labelText: String,
            alignCenter: Boolean,
            showTitle: Boolean,
        },
        data() {
            return {
                userData: this.$store.getters.getUserData,
                file: null,
                previewUrl: "",
                url: "",

                errExist: false,
                errMsg: "",
                progressBarActive: false,
                progressBarPercent: 0,
                recordVersion: "",
            }
        },
        mounted() {
            this.previewUrl = (!this.isUndefined(this.attachment.PreviewAttachmentURL) && this.attachment.PreviewAttachmentURL.length > 0) ?
                this.attachment.PreviewAttachmentURL : ""
            this.url = (!this.isUndefined(this.attachment.AttachmentURL) && this.attachment.AttachmentURL.length > 0) ?
                this.attachment.AttachmentURL : ""
            this.recordVersion = (!this.isUndefined(this.attachment.RVV) && this.attachment.RVV.length > 0) ?
                this.attachment.RVV : ""
        },
        methods: {
            async chunkFile(e) {
                this.file = e.target.files[0]
                let fileMaxSize = 104857600   //100Mb
                if (!this.isUndefined(this.attachment.FileMaxSize) && parseInt(this.attachment.FileMaxSize.toString()) > 0)
                    fileMaxSize = parseInt(this.attachment.FileMaxSize.toString())

                try {

                    if (this.file.size > fileMaxSize) {
                        let sizeInMb = Math.round(fileMaxSize / (1024 * 1024))
                        e.target.value = null
                        this.errExist = true
                        this.errMsg = "Размер файла превышает " + sizeInMb.toString() + " МБ"
                    } else if (!this.isUndefined(this.attachment.AllowedExtensions) &&
                        this.attachment.AllowedExtensions.length > 0 &&
                        !this.attachment.AllowedExtensions.includes(this.file.name.split('.').pop().toLowerCase())) {
                        e.target.value = null
                        this.errExist = true
                        this.errMsg = "Не разрешенный тип файла."
                    } else {
                        this.url = URL.createObjectURL(e.target.files[0])
                        this.previewUrl = this.url

                        e.target.value = null

                        const retries = 20
                        const chunkSize = 2621440 //2Mb

                        const fileName = this.file.name
                        const fileSize = this.file.size
                        const guid = this.newGuid()
                        let attachmentParams = this.attachmentParams
                        if (typeof attachmentParams === "undefined") attachmentParams = {}

                        let chunkCounter = 0
                        let chunkNumbers = Math.ceil(this.file.size / chunkSize)
                        let chunkStart = 0
                        let chunkEnd = chunkStart + chunkSize
                        let retryCounter = 0

                        this.progressBarActive = true
                        this.progressBarPercent = 0

                        this.errExist = false
                        this.errMsg = ""

                        this.$emit("getDownloadStatus", {"fileKey": this.attachment.FileKey, "status": true})

                        while (chunkCounter < chunkNumbers) {
                            retryCounter = 0
                            while (retryCounter < retries) {
                                chunkCounter++
                                chunkEnd = Math.min(chunkStart + chunkSize, this.file.size)
                                let chunk = this.file.slice(chunkStart, chunkEnd)

                                try {
                                    const formData = new FormData()
                                    formData.append("Session_UID", this.userData.Session_UID)
                                    formData.append("uuid", guid)
                                    formData.append("file", fileName)
                                    formData.append("ruid", this.recordUid)
                                    formData.append("filesize", fileSize)
                                    formData.append("chunkNumbers", chunkNumbers.toString())
                                    formData.append("chunk", chunkCounter.toString())
                                    formData.append(this.attachment.FileKey, chunk)
                                    formData.append("attfor", this.attachmentFor)
                                    formData.append("attparams", JSON.stringify(this.attachmentParams))

                                    const config = {
                                        headers: {
                                            "Content-Type": "multipart/form-data",
                                            "Content-Range": `${chunkStart}-${chunkEnd - 1}`
                                        },

                                        onUploadProgress: progressEvent => {
                                            this.progressBarPercent = Math.round((chunkCounter * 100) / chunkNumbers)
                                            retryCounter = retries + 1
                                        }

                                    }
                                    await axios.post("/fu/filechunkupload", formData, config)
                                        .then(({data}) => {
                                            if (this.isUndefined(data.success) || this.isUndefined(data.response)) {
                                                this.errExist = true
                                                this.errMsg = "Неверный формат ответа при загрузке файла."
                                                retryCounter = -1
                                            } else if (!data.success) {
                                                this.errExist = true
                                                this.errMsg = data.response
                                                retryCounter = -1
                                            } else {
                                                chunkStart += chunkSize
                                                retryCounter = retries + 1
                                            }
                                            //Сохраняем RV, если существует
                                            if (!this.isUndefined(data.data) && !this.isUndefined(data.data.R_RV)) {
                                                this.recordVersion = data.data.R_RV
                                            }
                                        })
                                        .catch((err) => {
                                            this.errExist = true
                                            this.errMsg = err.toString()
                                            console.log(err)
                                            retryCounter++
                                        })

                                } catch (e) {
                                    this.errExist = true
                                    this.errMsg = e.message
                                    console.log(e)
                                    retryCounter++
                                }

                                if (retryCounter === -1) break
                            }
                            if (retryCounter === -1) break
                        }

                        if (retryCounter >= 0 || retryCounter >= retries) {
                            this.errExist = false
                            this.errMsg = ""
                        }

                        this.progressBarPercent = 0
                        this.progressBarActive = false

                        this.$emit("getDownloadStatus", {"fileKey": this.attachment.FileKey, "status": false})
                    }
                } catch (e) {
                    this.errExist = true
                    this.errMsg = e.message
                    this.progressBarPercent = 0
                    this.progressBarActive = false
                    console.log("Unhandled error!")
                }
            },
            deleteFile() {
                if (this.disabled) return

                this.errExist = false
                this.errMsg = ""

                let attachmentParams = this.attachmentParams
                if (typeof attachmentParams === "undefined") attachmentParams = {}

                axios.post("/fu/ws.svc/DeleteAttachment", {
                        'Session_UID': this.userData.Session_UID,
                        'AttachmentFor': this.attachmentFor,
                        'R_UID': this.recordUid,
                        'R_FileKey': this.attachment.FileKey,
                        'R_RV': this.recordVersion,
                        'AttachmentParams': JSON.stringify(this.attachmentParams),

                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.url = ""
                                this.previewUrl = ""
                                this.file = null
                                this.recordVersion = ""
                            } else {
                                this.errExist = true
                                this.errMsg = resp.data.response.toString()
                            }
                        }
                    })
                    .catch(err => {
                        this.errExist = true
                        this.errMsg = err.message
                    })
            },
            previewFile() {
                this.$refs['modal-preview'].show()
            },
            saveFile() {

            },
            openFileSelection() {
                if (this.disabled) return

                this.$refs.fileInputRef.click()
            },
            getButtonContainerStyle() {
                return `position: absolute; bottom: 1px; left: 50%; width: ${this.width};transform: translateX(-50%); padding: 7px 0;`
            },
            getImgSrc() {
                let result = ""
                if (!this.isUndefined(this.url) && this.url.length > 0) {
                    if (!this.isUndefined(this.previewUrl) && this.previewUrl.length > 0)
                        result = this.previewUrl
                    else if (!this.isUndefined(this.attachment.FileExtension) && this.attachment.FileExtension.length > 0) {
                        let ext = this.getFileType

                        if (ext === "pdf")
                            result = "media/images/icons/outline/pdf.png"
                        else if (ext === "doc")
                            result = "media/images/icons/outline/doc.png"
                        else if (ext === "xls")
                            result = "media/images/icons/outline/xls.png"
                        else if (ext === "img")
                            result = "media/images/icons/outline/img.png"
                        else
                            result = "media/images/icons/outline/universal.png"
                    } else
                        result = "media/images/icons/outline/universal.png"

                } else {
                    result = "media/images/icons/outline/img-gray.png"
                }
                return result
            },
            getImgContainerStyle() {
                let center = ""
                if (this.alignCenter) center = ";margin: 0 auto"

                if (this.isUndefined(this.url) || this.url.length === 0)
                    return `width: ${this.width}; height: ${this.height}; border: 1px solid #ccc${center}`
                else
                    return `width: ${this.width}; height: ${this.height}${center}`
            },
            getMessageTextStyle() {
                return (this.alignCenter) ?
                    `position: absolute; top:10px; left: 52%; width: ${this.width}; transform: translateX(-50%);` :
                    `position: absolute; top:10px; left: 10px; width: ${this.width};`
            },
            buttonDeleteFileClicked() {
                this.$refs['modal-delete-confirmation'].show()
            },
            buttonDeleteConfirmCancelClicked() {
                this.$refs['modal-delete-confirmation'].hide()
            },
            buttonDeleteConfirmOkClicked() {
                this.deleteFile()
                this.$refs['modal-delete-confirmation'].hide()
            }
        },
        computed: {
            getFileExtensions: function () {
                let result = ".jpg,.jpeg,.png"
                if (!this.isUndefined(this.attachment.AllowedExtensions) && this.attachment.AllowedExtensions.length > 0) {
                    result = this.attachment.AllowedExtensions.join(",.")
                    result = "." + result
                }
                return result
            },
            getFileType: function () {
                let ext = this.attachment.FileExtension ? this.attachment.FileExtension.toString().toLowerCase() : ""
                let result = ""
                if (ext === "jpg" || ext === "jpeg" || ext === "png" || ext === "bmp") result = "img"
                else if (ext === "pdf") result = "pdf"
                else if (ext === "doc" || ext === "docx") result = "doc"
                else if (ext === "xls" || ext === "xlsx") result = "xls"

                return result
            }
        },
        watch: {
            attachment(newValue) {
                this.errExist = false
                this.errMsg = ""

                this.previewUrl = (!this.isUndefined(newValue.PreviewAttachmentURL) && newValue.PreviewAttachmentURL.length > 0) ?
                    newValue.PreviewAttachmentURL : ""
                this.url = (!this.isUndefined(newValue.AttachmentURL) && newValue.AttachmentURL.length > 0) ?
                    newValue.AttachmentURL : ""
                this.recordVersion = (!this.isUndefined(newValue.RVV) && newValue.RVV.length > 0) ?
                    newValue.RVV : ""
            }
        }
    }
</script>

<style scoped>
    .button-icon-only {
        padding: 0.4rem 0.75rem !important;
    }

    .preview-button, .save-button, .delete-button {
        width: 35px;
        margin-left: 10px;
    }

    .button-container {
        display: none;
        background-color: rgba(255, 255, 255, 0.6);
    }

    .img-uploader:hover > .button-container {
        display: block;
    }

    /deep/ .custom-modal-body {
        padding: 1rem !important;
    }

    /deep/ .custom-modal-header {
        padding: 1rem 1rem 0.5rem 1rem !important;
    }

</style>